"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

function scrollToTop() {
	window.scrollTo({ top: 0, left: 0, behavior: "auto" });
	document.documentElement.scrollTop = 0;
	document.body.scrollTop = 0;

	const mainScrollRegion = document.querySelector<HTMLElement>(
		".layout-main-content",
	);
	mainScrollRegion?.scrollTo({ top: 0, left: 0, behavior: "auto" });

	const feedScrollRegion = document.querySelector<HTMLElement>(
		"[data-feed-scroll-region]",
	);
	feedScrollRegion?.scrollTo({ top: 0, left: 0, behavior: "auto" });
}

/** Resets the app shell's scroll position after navigating to a new route. */
export function RouteScrollReset() {
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const routeKey = pathname ? `${pathname}?${searchParams.toString()}` : null;

	useEffect(() => {
		if (!routeKey) return;

		const frame = requestAnimationFrame(scrollToTop);
		return () => cancelAnimationFrame(frame);
	}, [routeKey]);

	return null;
}
